import * as api from '@/http'

export const ActionSetAssets = async ({ commit }) => {
  const assets = await api.http.get('dash/assets').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_assets', assets)
}

export const ActionStoreAsset = async ({ commit, dispatch }, data) => {
  const assets = await api.http.post('dash/assets', data).then((response) => response.body)
  dispatch('acquisitions/ActionSetInvoicesItems', {}, { root: true })
  commit('SET_assets', assets)
}
